var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 24.75C23.7969 24.75 25 23.6016 25 22.125L25 2.875C25 1.45313 23.7969 0.250002 22.375 0.250002L3.125 0.25C1.64844 0.25 0.5 1.45313 0.5 2.875L0.499998 22.125C0.499998 23.6016 1.64844 24.75 3.125 24.75L22.375 24.75ZM11.1641 19.3906C10.8359 19.7734 10.2344 19.7734 9.90625 19.3906L4.21875 13.7031C3.89062 13.375 3.89062 12.8281 4.21875 12.5L5.47656 11.2422C5.80469 10.9141 6.35156 10.9141 6.67969 11.2422L10.5625 15.0703L18.7656 6.86719C19.0937 6.53906 19.6406 6.53906 19.9687 6.86719L21.2266 8.125C21.5547 8.45313 21.5547 9 21.2266 9.32813L11.1641 19.3906Z",
    fill: "#8CC8BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toast-success.bc22147de31f25f301f99aeeda179e26.svg";
export { ForwardRef as ReactComponent };